export default report;


function report(obj){
  console.log('sent to server');
}


// WEBPACK FOOTER //
// ./src/mixins/report.js